import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import LoanProductSettingsListView from "./views/LoanProductSettingsListView";
import LoanProductSettingsDetailView from "./views/LoanProductSettingsDetailView";

export const loanProductSettingsRoutes: RouteObject[] = [
    {
        path: '/admin/loan-settings/products',
        element: <LoanProductSettingsListView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/loan-settings/products/:id',
        element: <LoanProductSettingsDetailView />,
        errorElement: <ErrorBoundary />,
    }
];
